import { HiArrowUp, HiArrowDown } from "react-icons/hi";
import StockAvatar from "../../strategy-detail/constituents/StockAvatar";
import { formatPercentage } from "../../../utils/numberFormat";

interface StockListItemProps {
  ticker: string;
  companyName: string;
  percentage: number;
  isPositive: boolean;
  stockDetails: { [key: string]: { name: string; logo: string } };
}

/**
 * Vertical stock list item showing logo aligned with ticker, company name, and percentage change on separate lines
 */
export const StockListItem = ({
  ticker,
  companyName,
  percentage,
  isPositive,
  stockDetails,
}: StockListItemProps) => {
  return (
    <div className="flex items-center gap-3 py-2 px-3 rounded-lg hover:bg-gray-50 transition-colors">
      {/* Stock Logo - centered vertically */}
      <div className="flex-shrink-0 self-center">
        <StockAvatar
          stockDetails={stockDetails}
          ticker={ticker}
          companyName={companyName}
        />
      </div>

      {/* Stock Info - stacked vertically */}
      <div className="flex-1 min-w-0 space-y-1">
        {/* Line 1: Ticker */}
        <div className="font-bold text-sm text-gray-900">{ticker}</div>

        {/* Line 2: Company Name */}
        <div className="text-xs text-gray-600 truncate">
          {stockDetails[ticker]?.name || companyName}
        </div>

        {/* Line 3: Percentage Value */}
        <div
          className={`inline-flex items-center gap-0.5 text-xs font-medium ${
            isPositive ? "text-green-700" : "text-red-700"
          }`}
        >
          {isPositive ? (
            <HiArrowUp size={12} />
          ) : (
            <HiArrowDown size={12} />
          )}
          {isPositive ? "+" : "-"}
          {formatPercentage(percentage)}
        </div>
      </div>
    </div>
  );
};

export default StockListItem;
